import { Layout, Result } from "antd";
import { Link } from "react-router-dom";
import Resources from "scripts/resources";

const Component = () => {
  return (
    <Layout className="sp-result-layout">
      <Result
        status="403"
        title={Resources.unauthorized}
        extra={
          <Link to="/" className="ant-btn ant-btn-primary">
            {Resources.backHome}
          </Link>
        }
      />
    </Layout>
  );
};

export default Component;
